import {
    DEFAULT_PAGINATION_SIZE,
    REPORT_INSTITUTION_COURSE_TABLE_HEADERS,
} from "../../utils/constants";

import classes from "./Report.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import React, {useEffect, useMemo, useState} from "react";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";

import YuJaButton from "../../components/standardization/YuJaButton";
import {useGlobalFilter, usePagination, useTable} from "react-table";
import styles from "../ManagePollsPage/ManagePolls.module.css";
import {Table} from "react-bootstrap";
import NormalPagination from "../../components/pagination/NormalPagination";
import {useHistory} from "react-router-dom";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import { useTranslation } from "react-i18next";

const getColumns = (t) => [
    { Header: t(REPORT_INSTITUTION_COURSE_TABLE_HEADERS.RANK.labelKey), accessor: REPORT_INSTITUTION_COURSE_TABLE_HEADERS.RANK.name, width: 90},
    { Header: t(REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_CODE.labelKey), accessor: REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_CODE.name, width: 120 },
    { Header: t(REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_NAME.labelKey), accessor: REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_NAME.name, width: 500 },
    { Header: t(REPORT_INSTITUTION_COURSE_TABLE_HEADERS.TOTAL_ACTIVITIES.labelKey), accessor: REPORT_INSTITUTION_COURSE_TABLE_HEADERS.TOTAL_ACTIVITIES.name, width: 100 },
    { Header: t(REPORT_INSTITUTION_COURSE_TABLE_HEADERS.ACTION.labelKey), id: REPORT_INSTITUTION_COURSE_TABLE_HEADERS.ACTION.name, accessor: "", width: 90 }
];

export default function TabCourses({data, setData, reportStartDate, reportEndDate}) {
    const { t } = useTranslation();
    const columns = useMemo(() => getColumns(t), [t]);
    let history = useHistory();

    const [keyword, setKeyword] = useState();
    const [pageIdx, setPageIdx] = useState(0);
    const [filter, setFilter] = useState({});
    const [sortedBy, setSortedBy] = useState("");


    const clickSearch = () => {
        setFilter({keyword});
        setPageIdx(0);
    }

    useEffect(() => {
        setGlobalFilter(filter);
    }, [data, filter]);




    const filterCustomize = (rows, _, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";
        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (values.courseName && values.courseName.toLowerCase().indexOf(filteredKeyword.toLowerCase()) > -1) {
                return true;
            }

            if (r.original.courseCode && r.original.courseCode.toLowerCase().indexOf(filteredKeyword.toLowerCase()) > -1) {
                return true;
            }

            return false;
        });
    };



    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize},
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: DEFAULT_PAGINATION_SIZE },
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);


    const onClickViewCourseReport = (courseId) => {
        if (!!courseId) {
            document.getElementsByTagName("main")[0].scrollTo(0, 0);
            history.push({
                pathname: `/report/course/${courseId}`,
                state: { reportStartDate, reportEndDate}
            });
        }
    }

    return (
        <>
            <div className={classes.tableSearchBox}>
                <YuJaTextBox
                    label={t("accessibility.searchPollTextbox")}
                    containerStyle={{fontSize: 15, marginLeft: 10, width: "70%"}}
                    placeholder={t("report.institutionTableSearchPlaceholder")}
                    onChange={e => setKeyword(e.target.value)}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                />
                <YuJaButton onClick={clickSearch}>
                    <div style={{fontSize: 14, lineHeight: 1.6,}}>{t("common.search")}</div>
                </YuJaButton>
            </div>
            <div className={classes.tableWrapper}>
                <Table hover {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, idx) => {
                                    if (
                                        [
                                            REPORT_INSTITUTION_COURSE_TABLE_HEADERS.RANK.name,
                                            REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_CODE.name,
                                            REPORT_INSTITUTION_COURSE_TABLE_HEADERS.COURSE_NAME.name
                                        ].includes(column.id)
                                    ) {
                                        return (
                                            <TableSortHeaderNew
                                                key={idx}
                                                data={data}
                                                setData={setData}
                                                sortedBy={sortedBy}
                                                setSortedBy={setSortedBy}
                                                propertyName={column.id}
                                                getProperty={(item) => item[column.id].toString()}
                                                label={column.Header}
                                                {...{
                                                    // ...column.getHeaderProps(),
                                                    key: column.id,
                                                    style: {
                                                        width: column.width,
                                                        textAlign: 'left',
                                                        backgroundClip: "padding-box",

                                                    }
                                                }}
                                            >
                                                <span
                                                    className={column.id === REPORT_INSTITUTION_COURSE_TABLE_HEADERS.RANK.name
                                                          ? classes.firstCell : classes.tableCell}
                                                >
                                                    {column.Header}
                                                </span>
                                            </TableSortHeaderNew>
                                        );
                                    } else {
                                        return (
                                            <th
                                                key={idx}
                                                {...column.getHeaderProps({
                                                    style: {
                                                        width: column.width,
                                                        textAlign: column.id === REPORT_INSTITUTION_COURSE_TABLE_HEADERS.ACTION.name ? 'center' : 'left'
                                                    }
                                                })}
                                            >
                                                <span className={ classes.tableCell}>
                                                    {column.Header}
                                                </span>
                                            </th>
                                        );
                                    }
                                })}
                            </tr>
                        ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                        {page && page.length !== 0 &&
                            page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr key={index}{...row.getRowProps()}>
                                        {row.cells.map((cell, index) => {
                                            if (cell.column.id === REPORT_INSTITUTION_COURSE_TABLE_HEADERS.ACTION.name) {
                                                return (
                                                    <td key={index} {...cell.getCellProps()} style={{textAlign: "center"}}>
                                                        <YuJaKebabMenuNew triggerAriaLabel={`${t("accessibility.actionsForPrefix")} ${row.original.courseName}`}>
                                                            <YuJaKebabMenuNew.Menu>
                                                                <YuJaKebabMenuNew.Item
                                                                    onClick={() => onClickViewCourseReport(cell.row.original.courseId)}>
                                                                    {t("report.courseTitle")}
                                                                </YuJaKebabMenuNew.Item>
                                                            </YuJaKebabMenuNew.Menu>
                                                        </YuJaKebabMenuNew>
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td key={index} >
                                                        <div className={cell.column.id === REPORT_INSTITUTION_COURSE_TABLE_HEADERS.RANK.name ? classes.firstCell : classes.tableCell}>
                                                            {cell.value}
                                                        </div>
                                                    </td>
                                                );
                                            }
                                        })}
                                    </tr>
                                );
                            })
                        }


                        {(!page || page.length === 0) &&
                            <tr>
                                <td colSpan="5" className={styles.noData} style={{boxShadow: "none"}}>
                                    <div
                                        style={{
                                            justifyContent: "center",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: 5,
                                            padding: 20
                                        }}
                                    >
                                        <NoResultIllustration/>
                                        <div style={{
                                            fontSize: "18px",
                                            marginTop: "10px",
                                            fontWeight: 600
                                        }}> {t("course.noResultsFound")} </div>
                                    </div>
                                </td>
                            </tr>

                        }
                    </tbody>
                </Table>
            </div>
            {page && pageCount > 1 &&
                <div style={{flex: 1, display: "flex", alignItems: "flex-end"}}>
                    <NormalPagination
                        pageCount={pageCount}
                        pageIndex={pageIndex}
                        pageOptions={pageOptions}
                        canPreviousPage={canPreviousPage}
                        canNextPage={canNextPage}
                        previousPage={previousPage}
                        nextPage={nextPage}
                        gotoPage={gotoPage}
                        paddingTop="0px"
                    />
                </div>
            }
        </>
    );
}